import { RattachementLogementModel } from './rattachement-logement.model';
import { CompoFoyerModel } from './compofoyer.model';
import { SituationFamilialeModel } from './situation-familiale.model';

/**
 * Structure en paramètre d'appel au service de calcul.
 * Il s'agit de la dto à envoyer en body à l'appel du service de calcul du droit
 */
export class FoyerModel {

    

    public rattachementLogementList: RattachementLogementModel[];

    public compoFoyerList: CompoFoyerModel[];

    public situationFamilialeList: SituationFamilialeModel[];
}
